import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Game as CommonGame } from 'js/components/common/Game';
import {
    carouselGamesStep,
    carouselRenderingTemp,
    pageGamesStep
} from './deviceDetails';
import { usePortletSelector } from 'js/components/system/Portlet';
import { prop } from 'ramda';
import style from './index.scss';
import { useDeviceSelector } from 'js/store/hooks';
import Skeleton from 'js/components/main/Games/Skeleton';

export const OverflowGamesSlider = ({
                                      setIsShowViewMore,
                                      gameCodes,
                                      Game = CommonGame,
                                      showGameInfo,
                                      showFeatureIcons = true,
                                      isTopCategory,
                                      categoryRef,
                                      showDivider,
                                      setSlideRef,
                                      isMobileSpecialCategory,
                                      displayName,
                                      mostPlayedGame
                                  }) => {
    const { orientation, formFactor } = useDeviceSelector();
    const carouselGamesNumberToRender = carouselGamesStep[formFactor][orientation];
    const carouselBuffer = carouselRenderingTemp[formFactor];
    const pageGamesNumberToRender = pageGamesStep[formFactor][orientation];
    const defaultGamesForRender = gameCodes.slice(0, pageGamesNumberToRender);
    const [readyForRender, setGamesForRender] = useState(defaultGamesForRender);
    const { tabs } = usePortletSelector(prop('groupedFilteredCategories'));
    const checkCounter = () => {
        if (categoryRef.current?.firstChild?.lastChild) {
            const game = categoryRef.current?.firstChild?.lastChild;
            const { width: gamesCarouselWidth } = categoryRef.current.getBoundingClientRect();
            const { width: gameWidth } = game.getBoundingClientRect();
            const marginLeftGame = parseFloat(getComputedStyle(game).marginLeft);
            const marginRightGame = parseFloat(getComputedStyle(game).marginRight);
            const gamesWithMargins = (marginLeftGame + gameWidth + marginRightGame) * gameCodes.length;
            setIsShowViewMore(gamesWithMargins > gamesCarouselWidth);
        } else {
            setIsShowViewMore(false);
        }
    };

    const updateResizeDevice = () => {
        const getOrientation = () => window.screen?.orientation?.type.includes('portrait') ? 'portrait' : 'landscape';
        const deviceOrientation = getOrientation();
        setGamesForRender(gameCodes.slice(0, pageGamesStep[formFactor][deviceOrientation]));
    };

    useEffect(() => {
        window.addEventListener('resize', checkCounter);

        return () => {
            window.removeEventListener('resize', checkCounter);
        };
    }, [orientation]);

    useEffect(() => {
        window.addEventListener('orientationchange', updateResizeDevice);

        return () => {
            window.removeEventListener('orientationchange', updateResizeDevice);
        };
    }, [tabs]);

    useEffect(() => {
        checkCounter();
    }, [gameCodes]);

    useEffect(() => {
        setGamesForRender(defaultGamesForRender);
    }, [tabs]);

    const handleScrollSlider = () => {
        const {
            scrollLeft,
            scrollWidth: scrollAreaWidth,
            clientWidth: scrollViewportWidth
        } = categoryRef.current.firstChild;
        const sliderPosition = scrollLeft + scrollViewportWidth;

        if (scrollAreaWidth - sliderPosition > carouselBuffer) {
            return;
        }

        if (readyForRender.length === gameCodes.length) {
            return;
        }

        setGamesForRender(prevItems => [
            ...prevItems,
            ...gameCodes.slice(prevItems.length, prevItems.length + carouselGamesNumberToRender)
        ]);
    };

    const lazy = () => {
        if (categoryRef.current?.firstChild?.childElementCount && 'IntersectionObserver' in window) {
            const intersectionAreaOptions = {
                root: categoryRef.current,
                rootMargin: '0px',
                threshold: 0.00
            };

            const handleImageInViewport = (entries) => {
                entries.forEach((entry) => {
                    const image = entry.target;
                    image.style.backgroundImage = `url("${image.dataset.src}")`;
                    imageObserver.unobserve(image);
                });
            };

            const imageObserver = new IntersectionObserver(handleImageInViewport, intersectionAreaOptions);
            const lazyImages = categoryRef.current.querySelectorAll('[loading="lazy"]');

            lazyImages.forEach(image => {
                imageObserver.observe(image);
            });

            return () => {
                lazyImages.forEach(image => {
                    imageObserver.unobserve(image);
                });
            };
        }
    };

    useLayoutEffect(() => {
        lazy();
    }, [categoryRef.current?.firstChild?.childElementCount, readyForRender]);

    return (
        <div>
            {readyForRender.length ?
                (<div ref={categoryRef}>
                        {isTopCategory ?
                            (<div className={`${style.games} ${style.topGames} ${isMobileSpecialCategory ? style[isMobileSpecialCategory] : ''}`}
                                  ref={setSlideRef}
                                  onScroll={handleScrollSlider}>
                                    {readyForRender?.map((code, index) =>
                                        <div className={index > 8 ? style.twoDigitGame : style.oneDigitGame} key={index}>
                                            <Game key={code}
                                                  code={code}
                                                  withFlexWidth={false}
                                                  showGameInfo={showGameInfo}
                                                  className={`${style.game} ${showDivider ? style.divider : ''}`}
                                                  showFeatureIcons={showFeatureIcons}
                                                  displayName={displayName}
                                                  mostPlayedGame={mostPlayedGame}
                                            />
                                            <div className={`${style.counter} ${index ? ' ' : style.firstCounter}`}></div>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className={`${style.games} ${isMobileSpecialCategory ? style[isMobileSpecialCategory] : ''}`}
                                     ref={setSlideRef}
                                     onScroll={handleScrollSlider}>
                                    {readyForRender?.map((code) =>
                                        <Game key={code}
                                              code={code}
                                              withFlexWidth={false}
                                              showGameInfo={showGameInfo}
                                              className={`${style.game} ${showDivider ? style.divider : ''}`}
                                              showFeatureIcons={showFeatureIcons}
                                              isMobileSpecialCategory={isMobileSpecialCategory}
                                              displayName={displayName}
                                              mostPlayedGame={mostPlayedGame}
                                        />)}
                                </div>
                            )
                        }

                    </div>
                ) : (
                    <Skeleton/>
                )
            }
        </div>
    );
};

export default OverflowGamesSlider;
